import { create } from "zustand";

interface PreferencesFilterState {
  // Toggle states
  enabledSizeTypes: string[]; // ["women_tops", "women_shoes"]
  enableBrands: boolean;

  // Context (facet distribution'dan gelen)
  relevantTypes: string[]; // Bu arama için alakalı type'lar

  // Actions
  toggleSizeType: (type: string) => void;
  setEnabledSizeTypes: (types: string[]) => void;
  toggleBrands: () => void;
  setRelevantTypes: (types: string[]) => void;
  reset: () => void;
}

export const usePreferencesFilterStore = create<PreferencesFilterState>(
  (set) => ({
    // Initial state
    enabledSizeTypes: [],
    enableBrands: false,
    relevantTypes: [],

    // Actions
    toggleSizeType: (type) =>
      set((state) => ({
        enabledSizeTypes: state.enabledSizeTypes.includes(type)
          ? state.enabledSizeTypes.filter((t) => t !== type)
          : [...state.enabledSizeTypes, type],
      })),

    setEnabledSizeTypes: (types) => set({ enabledSizeTypes: types }),

    toggleBrands: () => set((state) => ({ enableBrands: !state.enableBrands })),

    setRelevantTypes: (types) => set({ relevantTypes: types }),

    reset: () =>
      set({
        enabledSizeTypes: [],
        enableBrands: false,
        relevantTypes: [],
      }),
  })
);

